// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .show-events-button{
    padding: 10px 20px;
    background-color: #007bff;
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}
  
.show-events-button:hover{
    background-color: rgb(58, 98, 182);
} */

.events-container {
    position: fixed;
    top: 50%;
    left: 50%;
    height: 70%;
    width: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 10px;
    padding: 20px;
    color:rgb(0, 136, 255);
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);
    z-index: 1000;
    display: none;
    overflow :auto;
}
  
.events-container.active {
    display: block;
}

/* show event css */
.event-header, .edit-row, .event-card-header{
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.edit-row{
    padding-right:30px;
}

.close-x{
    background-color: rgba(234, 13, 9, 0.884);
    border-color: rgba(234, 13, 9, 0.884);
    border-radius:0.5em;
    color: white;
    margin-bottom: 0.5em;
    margin-right: 0.5em;
    font-size: 20px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

.close-x:hover {
    background-color: #913f3f;
    border-color: #913f3f;
}

.filter-button {
    background-color: #007bff;
    color: white;
    border: none;
    padding: 5px;
    padding-left: 10px;
    padding-right:10px;
    margin: 5px;
    cursor: pointer;
    border-radius: 5px;
}

.filter-button:hover, .toggle-filters:hover, .toggle-extra:hover, #edit-button:hover{
    background-color: #0056b3;
}



.toggle-filters, .toggle-extra{
    background-color: #007bff97;
    color: white;
    border: none;
    padding: 5px;
    padding-left: 10px;
    padding-right:10px;
    margin: 5px;
    cursor: pointer;
    border-radius: 5px;
}


/* event card displays */
.event-card{
    clear:both;
    margin-top:5px;
    margin-bottom:5px;
    padding:10px;
    border-radius: 10px;
    box-shadow: 0px 0px 10px rgba(111, 182, 245, 0.5);
}


.event-image{
    height: 40%;
    width: 40%;
    border-radius: 10%;
}


.event-title{
    font-size:18px;
    text-align: centre;
    margin:none;
}

.time-and-date-container{
    float:right;
    width:57%;
    display: grid;
    padding-left:10px;
    grid-template-columns: auto auto;
}


.event-start-date, .event-end-date, .event-start-time, .event-end-time{
    font-family:Arial, Helvetica, sans-serif;
    font-size:14px;
}


.event-tag{
    border: 1px solid #007bfff6;;
    border-radius: 1em;
    margin: 0.25em;
    padding:10px;
    font-size: 12px;
    display:inline-block;
    text-align:center;
}



@media(max-width:600px){
    .event-image{
        height: 100%;
        width: 100%;
        border-radius: 10%;
    }

    .time-and-date-container{
        float:none;
        align-items:center;
    }
}

.event-description{
    clear:both;
    font-family:Arial, Helvetica, sans-serif;
    font-size:14px;
    padding-top:10px;
}


.event-postcode{
    clear:both;
    grid-area: postcode;
    margin-top:5px;
}

.event-check-ins{
    float:left;
}

.event-likes{
    float:left;
}

.event-end-date, .event-end-time, .event-likes{
    margin-left: 10px;
}

.view-profile{
    background-color: white;
    color: rgb(0, 136, 255);
    border:none;
    text-decoration: underline;
    font-size: 16px;
    cursor: pointer;
}


#check-in-button, #like-button, #view-comments-button, #add-comment-button, #report-button{
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    padding: 5px 10px;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
}

#report-button{
    background-color: rgb(127, 135, 153);
    padding:5px 10px;
}

#report-button:hover{
    background-color: rgb(92, 98, 111);
}


#view-comments-button, #add-comment-button{
    background-color: #007bff;
}


#view-comments-button:hover, #add-comment-button:hover{
    background-color: #0956a8;
}

.edit-info-button, #edit-button, #delete-event-button, #network-button, #close-profile-button, #delete-profile-button{
    padding: 5px 10px;
    background-color: #007bff;
    border: none;
    border-radius: 1em;
    color: white;
    margin: 0.25em;
    font-size: 12px;
    cursor: pointer;
    transition: background-color 0.3s ease, colour 0.3s ease;
   
}


#network-button{
    background-color: #00bbff;
}

#network-button:hover{
    background-color: #0091c6;
}

#like-button, #delete-event-button, #delete-profile-button{
    background-color: rgba(237, 31, 28, 0.738)
}
  
#like-button:hover, #delete-event-button:hover, #delete-profile-button:hover {
    background-color: #913f3f;
}


/* #edit-button {
    background-color: #007bff97;
    margin-right: 5px;
}  */

.edit-info-button:hover{
    background-color: rgba(34, 43, 172, 0.871);
}




`, "",{"version":3,"sources":["webpack://./src/css/eventsList.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;GAcG;;AAEH;IACI,eAAe;IACf,QAAQ;IACR,SAAS;IACT,WAAW;IACX,UAAU;IACV,gCAAgC;IAChC,uBAAuB;IACvB,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,2CAA2C;IAC3C,aAAa;IACb,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,yCAAyC;IACzC,qCAAqC;IACrC,mBAAmB;IACnB,YAAY;IACZ,oBAAoB;IACpB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;AAC7B;;;;AAIA;IACI,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,kBAAkB;AACtB;;;AAGA,wBAAwB;AACxB;IACI,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;IACnB,iDAAiD;AACrD;;;AAGA;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;;AAGA;IACI,cAAc;IACd,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,SAAS;IACT,aAAa;IACb,iBAAiB;IACjB,gCAAgC;AACpC;;;AAGA;IACI,wCAAwC;IACxC,cAAc;AAClB;;;AAGA;IACI,2BAA2B;IAC3B,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;;;AAIA;IACI;QACI,YAAY;QACZ,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,UAAU;QACV,kBAAkB;IACtB;AACJ;;AAEA;IACI,UAAU;IACV,wCAAwC;IACxC,cAAc;IACd,gBAAgB;AACpB;;;AAGA;IACI,UAAU;IACV,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;IACvB,WAAW;IACX,0BAA0B;IAC1B,eAAe;IACf,eAAe;AACnB;;;AAGA;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,wDAAwD;AAC5D;;AAEA;IACI,oCAAoC;IACpC,gBAAgB;AACpB;;AAEA;IACI,kCAAkC;AACtC;;;AAGA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,wDAAwD;;AAE5D;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;;;IAGI;;AAEJ;IACI,0CAA0C;AAC9C","sourcesContent":["/* .show-events-button{\n    padding: 10px 20px;\n    background-color: #007bff;\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n  \n.show-events-button:hover{\n    background-color: rgb(58, 98, 182);\n} */\n\n.events-container {\n    position: fixed;\n    top: 50%;\n    left: 50%;\n    height: 70%;\n    width: 50%;\n    transform: translate(-50%, -50%);\n    background-color: white;\n    border-radius: 10px;\n    padding: 20px;\n    color:rgb(0, 136, 255);\n    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.5);\n    z-index: 1000;\n    display: none;\n    overflow :auto;\n}\n  \n.events-container.active {\n    display: block;\n}\n\n/* show event css */\n.event-header, .edit-row, .event-card-header{\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.edit-row{\n    padding-right:30px;\n}\n\n.close-x{\n    background-color: rgba(234, 13, 9, 0.884);\n    border-color: rgba(234, 13, 9, 0.884);\n    border-radius:0.5em;\n    color: white;\n    margin-bottom: 0.5em;\n    margin-right: 0.5em;\n    font-size: 20px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n.close-x:hover {\n    background-color: #913f3f;\n    border-color: #913f3f;\n}\n\n.filter-button {\n    background-color: #007bff;\n    color: white;\n    border: none;\n    padding: 5px;\n    padding-left: 10px;\n    padding-right:10px;\n    margin: 5px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n.filter-button:hover, .toggle-filters:hover, .toggle-extra:hover, #edit-button:hover{\n    background-color: #0056b3;\n}\n\n\n\n.toggle-filters, .toggle-extra{\n    background-color: #007bff97;\n    color: white;\n    border: none;\n    padding: 5px;\n    padding-left: 10px;\n    padding-right:10px;\n    margin: 5px;\n    cursor: pointer;\n    border-radius: 5px;\n}\n\n\n/* event card displays */\n.event-card{\n    clear:both;\n    margin-top:5px;\n    margin-bottom:5px;\n    padding:10px;\n    border-radius: 10px;\n    box-shadow: 0px 0px 10px rgba(111, 182, 245, 0.5);\n}\n\n\n.event-image{\n    height: 40%;\n    width: 40%;\n    border-radius: 10%;\n}\n\n\n.event-title{\n    font-size:18px;\n    text-align: centre;\n    margin:none;\n}\n\n.time-and-date-container{\n    float:right;\n    width:57%;\n    display: grid;\n    padding-left:10px;\n    grid-template-columns: auto auto;\n}\n\n\n.event-start-date, .event-end-date, .event-start-time, .event-end-time{\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:14px;\n}\n\n\n.event-tag{\n    border: 1px solid #007bfff6;;\n    border-radius: 1em;\n    margin: 0.25em;\n    padding:10px;\n    font-size: 12px;\n    display:inline-block;\n    text-align:center;\n}\n\n\n\n@media(max-width:600px){\n    .event-image{\n        height: 100%;\n        width: 100%;\n        border-radius: 10%;\n    }\n\n    .time-and-date-container{\n        float:none;\n        align-items:center;\n    }\n}\n\n.event-description{\n    clear:both;\n    font-family:Arial, Helvetica, sans-serif;\n    font-size:14px;\n    padding-top:10px;\n}\n\n\n.event-postcode{\n    clear:both;\n    grid-area: postcode;\n    margin-top:5px;\n}\n\n.event-check-ins{\n    float:left;\n}\n\n.event-likes{\n    float:left;\n}\n\n.event-end-date, .event-end-time, .event-likes{\n    margin-left: 10px;\n}\n\n.view-profile{\n    background-color: white;\n    color: rgb(0, 136, 255);\n    border:none;\n    text-decoration: underline;\n    font-size: 16px;\n    cursor: pointer;\n}\n\n\n#check-in-button, #like-button, #view-comments-button, #add-comment-button, #report-button{\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    padding: 5px 10px;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n}\n\n#report-button{\n    background-color: rgb(127, 135, 153);\n    padding:5px 10px;\n}\n\n#report-button:hover{\n    background-color: rgb(92, 98, 111);\n}\n\n\n#view-comments-button, #add-comment-button{\n    background-color: #007bff;\n}\n\n\n#view-comments-button:hover, #add-comment-button:hover{\n    background-color: #0956a8;\n}\n\n.edit-info-button, #edit-button, #delete-event-button, #network-button, #close-profile-button, #delete-profile-button{\n    padding: 5px 10px;\n    background-color: #007bff;\n    border: none;\n    border-radius: 1em;\n    color: white;\n    margin: 0.25em;\n    font-size: 12px;\n    cursor: pointer;\n    transition: background-color 0.3s ease, colour 0.3s ease;\n   \n}\n\n\n#network-button{\n    background-color: #00bbff;\n}\n\n#network-button:hover{\n    background-color: #0091c6;\n}\n\n#like-button, #delete-event-button, #delete-profile-button{\n    background-color: rgba(237, 31, 28, 0.738)\n}\n  \n#like-button:hover, #delete-event-button:hover, #delete-profile-button:hover {\n    background-color: #913f3f;\n}\n\n\n/* #edit-button {\n    background-color: #007bff97;\n    margin-right: 5px;\n}  */\n\n.edit-info-button:hover{\n    background-color: rgba(34, 43, 172, 0.871);\n}\n\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
